module.exports = __webpack_public_path__ + "img/cat-expression.a5f96052.png";